<template>
  <v-list-item v-if="checkRightStatus(15)" @click="deleteCustomer(Customer)">
    <v-list-item-title>{{ $t("buttons.delete") }}</v-list-item-title>
  </v-list-item>
</template>

<script>
import { mapGetters } from "vuex";
import customerService from "../service.js";

export default {
  props: ["Customer"],
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    deleteCustomer() {
      if (!this.checkRightStatus(39)) {
        this.$swal(
          "Delete Customer",
          "You are not allow to delete customer with balance.",
          "warning"
        );
        return false;
      }
      this.$swal({
        title: "Are you sure?",
        html: `You want to delete <strong style="text-transform: capitalize">${this.Customer.fatherName}</strong>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          customerService
            .delete(this.Customer.id)
            .then((response) => {
              if (response.data) {
                this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Parent was deleted",
                });
                // this.$swal("Deleted!", "Customer has been deleted.", "success");
                this.$emit("submit");
              }
            })
            .catch((error) => {
              throw error;
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
